import { formatMonthLabel } from "../month/monthSeo.js";

const SITE_URL = "https://premierelens.com";

export function buildBestOfSeoMeta(yearMonth, options = {}) {
  const { count = 0, topShows = [] } = options;
  const label = formatMonthLabel(yearMonth);
  const title = `Best New and Returning TV of ${label} | PremiereLens`;

  let description;
  if (count > 0 && topShows.length > 0) {
    const preview = topShows.slice(0, 3).join(", ");
    description = `Our top ${count} TV premieres for ${label}, ranked by rating. Highlights include ${preview}.`;
  } else if (count > 0) {
    description = `Our top ${count} TV premieres for ${label}, ranked by rating and curation signals.`;
  } else {
    description = `The best TV premieres for ${label}, curated and ranked by PremiereLens.`;
  }

  if (description.length > 155) {
    description = `${description.slice(0, 152).trimEnd()}...`;
  }

  const canonicalUrl = `${SITE_URL}/best-of/${yearMonth}`;
  return {
    title,
    description,
    canonicalUrl,
    ogUrl: canonicalUrl,
    image: `${SITE_URL}/og-image.jpg`,
    robots: "index,follow",
    ogType: "article",
    label,
  };
}
